export default "__VITE_ASSET__CwEV5usx__"